<template>
  <div class="countdown-edit"></div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
@import "./edit.scss";
</style>
